import React from 'react'

function ProviderTab(): React.ReactElement {
  return <div>...</div>
}

export default ProviderTab
